// extracted by mini-css-extract-plugin
export default {"ColSty":"CurrentThirtyDaysBsa_ColSty__-Ldat"};